class FeaturedCollections extends HTMLElement {
  constructor() {
    super();

    this.carousel = this.querySelector("swiper-container");
  }

  connectedCallback() {
    this.addCarouselParameters();
  }

  addCarouselParameters() {
    Object.assign(this.carousel, {
      slidesPerView: 1.67,
      spaceBetween: 12,
      slidesOffsetAfter: 16,
      slidesOffsetBefore: 16,
      roundLenghts: true,
      mousewheel: {
        enabled: true,
        forceToAxis: true
      },
      breakpoints: {
        520: {
          slidesPerView: "auto"
        },
        767: {
          slidesPerView: "auto",
          slidesOffsetAfter: 0,
          slidesOffsetBefore: 0
        },
        1024: {
          slidesPerView: "auto",
          spaceBetween: 24,
          slidesOffsetAfter: 0,
          slidesOffsetBefore: 0
        },
        1280: {
          slidesPerView: "auto",
          spaceBetween: 24,
          slidesOffsetAfter: 0,
          slidesOffsetBefore: 0
        }
      },
      on: {
        init: swiper => {
          swiper.el.style.overflow = "visible";
        }
      }
    });

    this.carousel.initialize();
  }
}

if (!customElements.get("featured-collections")) customElements.define("featured-collections", FeaturedCollections);
